export default "__VITE_ASSET__2759f39a__"